	var initESW = function(gslbBaseURL) {
		embedded_svc.settings.displayHelpButton = true; //或为假
		embedded_svc.settings.language = 'en-US'; //例如，输入 'en' 或 'en-US'

		//embedded_svc.settings.defaultMinimizedText = '...'; //（默认设置为与专家聊天）
		//embedded_svc.settings.disabledMinimizedText = '...'; //（默认设置为客服人员离线）

		//embedded_svc.settings.loadingText = ''; //（默认设置为正在加载）
		//embedded_svc.settings.storageDomain = 'yourdomain.com'; //（为部署设置域，这样访客可在聊天会话期间导航子域。）

		// 聊天 的设置
		//embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
			// Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
			// Returns a valid button ID.
		//};
		//embedded_svc.settings.prepopulatedPrechatFields = {}; //设置自动填充聊天前表单格字段
		//embedded_svc.settings.fallbackRouting = []; //按钮 ID、用户 ID 或 userId_buttonId 的数组
		//embedded_svc.settings.offlineSupportMinimizedText = '...'; //（默认设置为联系我们）

		embedded_svc.settings.enabledFeatures = ['LiveAgent'];
		embedded_svc.settings.entryFeature = 'LiveAgent';

		embedded_svc.init(
			'https://voxtech2021.my.salesforce.com',
			'https://help.shokz.com.au/',
			gslbBaseURL,
			'00D5g00000Bj0qN',
			'Shokz_Australia_Chat_Agents',
			{
				baseLiveAgentContentURL: 'https://c.la2-c1-ukb.salesforceliveagent.com/content',
				deploymentId: '5725g000000xBWp',
				buttonId: '5735g000000xbel',
				baseLiveAgentURL: 'https://d.la2-c1-ukb.salesforceliveagent.com/chat',
				eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I5g000000x5A8EAI_187bd02ee17',
				isOfflineSupportEnabled: false
			}
		);
	};

	if (!window.embedded_svc) {
		var s = document.createElement('script');
		s.setAttribute('src', 'https://voxtech2021.my.salesforce.com/embeddedservice/5.0/esw.min.js');
		s.onload = function() {
			initESW(null);
		};
		document.body.appendChild(s);
	} else {
		initESW('https://service.force.com');
	}
